export let ug_p21ext_1_215 = {
	"name": "ug_p21ext_1_215",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "При каких условиях обоснованный риск признается уголовным законом (ст. 41 УК РФ) обстоятельством, исключающим преступность деяния?",
				"correct_ans": [
					{
						"comm": "По ст. 41 «Обоснованный риск» УК РФ не является преступлением причинение вреда охраняемым уголовным законом интересам при обоснованном риске для достижения общественно полезной цели.",
						"ans": "Достижение общественно полезной цели",
						"score": 36
					},
					{
						"comm": "По ст. 41 «Обоснованный риск» УК РФ риск признается обоснованным, если указанная цель не могла быть достигнута не связанными с риском действиями (бездействием) и лицо, допустившее риск, предприняло достаточные меры для предотвращения вреда охраняемым уголовным законом интересам.",
						"ans": "Риск признается обоснованным, если указанная цель не могла быть достигнута не связанными с риском действиями (бездействием) и лицо, допустившее риск, предприняло достаточные меры для предотвращения вреда охраняемым уголовным законом интересам",
						"score": 36
					},
					{
						"comm": "По ст. 41 «Обоснованный риск» УК РФ риск не признается обоснованным, если он заведомо был сопряжен с угрозой для жизни многих людей, с угрозой экологической катастрофы или общественного бедствия.",
						"ans": "Риск не признается обоснованным, если он заведомо был сопряжен с угрозой для жизни многих людей, с угрозой экологической катастрофы или общественного бедствия",
						"score": 36
					}
				],
				"wrong_ans": [
					{
						"ans": "Компетентность лица, допускающего риск",
						"score": 0
					},
					{
						"ans": "Должностное положение, позволяющее лицу принимать рискованные решения",
						"score": 0
					},
					{
						"ans": "Санкционирование риска вышестоящим должностным лицом",
						"score": 0
					},
					{
						"ans": "Причинение меньшего вреда по сравнению с предотвращенным рискованными действиями",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "По ст. 41 «Обоснованный риск» УК РФ не является преступлением причинение вреда охраняемым уголовным законом интересам при обоснованном риске для достижения общественно полезной цели",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let ug_p21ext_1_84 = {
	"name": "ug_p21ext_1_84",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Для каких преступлений против личности установлен пониженный минимальный возраст уголовной ответственности?",
				"correct_ans": [
					{
						"ans": "Убийство (ст. 105 УК РФ)",
						"score": 18
					},
					{
						"ans": "Умышленное причинение тяжкого вреда здоровью (ст. 111 УК РФ)",
						"score": 18
					},
					{
						"ans": "Умышленное причинение средней тяжести вреда здоровью (ст. 112 УК РФ)",
						"score": 18
					},
					{
						"ans": "Похищение человека (ст. 126 УК РФ)",
						"score": 18
					},
					{
						"ans": "Изнасилование (ст. 131 УК РФ)",
						"score": 18
					},
					{
						"ans": "Насильственные действия сексуального характера (ст. 132 УК РФ)",
						"score": 18
					}
				],
				"wrong_ans": [
					{
						"ans": "Убийство матерью новорожденного ребенка (ст. 106 УК РФ)",
						"score": 0
					},
					{
						"ans": "Убийство, совершенное в состоянии аффекта (ст. 107 УК РФ)",
						"score": 0
					},
					{
						"ans": "Убийство, совершенное при превышении пределов необходимой обороны, либо при превышении мер, необходимых для задержания лица, совершившего преступление (ст. 108 УК РФ)",
						"score": 0
					},
					{
						"ans": "Причинение смерти по неосторожности (ст. 109 УК РФ)",
						"score": 0
					},
					{
						"ans": "Доведение до самоубийства (ст. 110 УК РФ)",
						"score": 0
					},
					{
						"ans": "Причинение тяжкого или средней тяжести вреда здоровью в состоянии аффекта (ст. 113 УК РФ)",
						"score": 0
					},
					{
						"ans": "Причинение тяжкого или средней тяжести вреда здоровью при превышении пределов необходимой обороны либо при превышении мер, необходимых для задержания лица, совершившего преступление (ст. 114 УК Ф)",
						"score": 0
					},
					{
						"ans": "Понуждение к действиям сексуального характера (ст. 133 УК РФ)",
						"score": 0
					},
					{
						"ans": "Развратные действия (ст. 135 УК РФ)",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "В ст. 20 среди статей УК РФ по которым подлежат уголовной ответственности лица, достигшие ко времени совершения преступления четырнадцатилетнего возраста указаны следующие посягающие на личность деяния: убийство (статья 105), умышленное причинение тяжкого вреда здоровью (статья 111), умышленное причинение средней тяжести вреда здоровью (статья 112), похищение человека (статья 126), изнасилование (статья 131), насильственные действия сексуального характера (статья 132)",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let ug_p21ext_1_140 = {
	"name": "ug_p21ext_1_140",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Кто может нести уголовную ответственность за причинение вреда при исполнении приказа или распоряжения?",
				"correct_ans": [
					{
						"ans": "Как лица, действовавшие во исполнение заведомо незаконных приказов и распоряжений, так и лица, отдававшие незаконные приказы и распоряжения",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Только лица, действовавшие во исполнение обязательных для них приказов и распоряжений",
						"score": 0
					},
					{
						"ans": "Только лица, отдавшие приказы или распоряжения, при исполнении которых причинен вред интересам третьих лиц",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "По ст. 42 «Исполнение приказа или распоряжения» УК РФ не является преступлением причинение вреда охраняемым уголовным законом интересам лицом, действующим во исполнение обязательных для него приказа или распоряжения. Уголовную ответственность за причинение такого вреда несет лицо, отдавшее незаконные приказ или распоряжение. Лицо, совершившее умышленное преступление во исполнение заведомо незаконных приказа или распоряжения, несет уголовную ответственность на общих основаниях"
}

export let ug_p21ext_1_192 = {
	"name": "ug_p21ext_1_192",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Каковы последствия если после совершения преступления у виновного лица наступило психическое расстройство, делающее невозможным назначение или исполнение наказания?",
				"correct_ans": [
					{
						"ans": "Лицу могут быть назначены судом принудительных мер медицинского характера",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Безусловное назначение принудительных мер медицинского характера",
						"score": 0
					},
					{
						"ans": "Освобождение от уголовной ответственности и обязательная передача необходимых материалов в федеральный орган исполнительной власти в сфере здравоохранения или орган исполнительной власти субъекта Российской Федерации в сфере здравоохранения для решения вопроса о лечении указанного лица",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "По ст. 97 «Основания применения принудительных мер медицинского характера» УК РФ принудительные меры медицинского характера могут быть назначены судом лицам у которых после совершения преступления наступило психическое расстройство, делающее невозможным назначение или исполнение наказания"
}

export let ug_p21ext_1_46 = {
	"name": "ug_p21ext_1_46",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Что такое общий объект преступления (общее понятие объекта преступления)?",
				"correct_ans": [
					{
						"ans": "Совокупность всех общественных отношений, охраняемых уголовным законом",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Совокупность общественных отношений, на которые посягают все преступления, предусмотренные нормами одного из разделов Особенной части Уголовного кодекса",
						"score": 0
					},
					{
						"ans": "Субстанция, на которую в конечном счете посягает противоправное деяние",
						"score": 0
					},
					{
						"ans": "Нарушаемая преступлением социальная категория",
						"score": 0
					},
					{
						"ans": "Общество в целом",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "В теории уголовного права общим объектом преступления признается совокупность всех общественных отношений, охраняемых УК РФ"
}

export let ug_p21ext_1_239 = {
	"name": "ug_p21ext_1_239",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Можно ли квалифицировать убийство двух лиц по п. \"а\" ч. 2 ст. 105 УК РФ, если одно из убийств было совершено при превышении пределов необходимой обороны?",
				"correct_ans": [
					{
						"ans": "Нет, нельзя",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Да, можно",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "По Постановлению Пленума Верховного Суда РФ от 27.01.1999 N 1 \"О судебной практике по делам об убийстве (ст. 105 УК РФ)\" убийство не должно расцениваться как совершенное по признаку, предусмотренному п. \"а\" ч. 2 ст. 105 УК РФ, если оно совершено при превышении пределов необходимой обороны"
}

export let ug_p21ext_1_159 = {
	"name": "ug_p21ext_1_159",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Кто не может быть осужден к ограничению свободы?",
				"correct_ans": [
					{
						"ans": "Военнослужащие, иностранные граждане, лица без гражданства",
						"score": 54
					},
					{
						"ans": "Лица, не имеющим места постоянного проживания на территории Российской Федерации",
						"score": 54
					}
				],
				"wrong_ans": [
					{
						"ans": "Лица, не достигшие 18 летнего возраста",
						"score": 0
					},
					{
						"ans": "Лица с психическим расстройством, не исключающим вменяемость",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Согласно ст. 53 «Ограничение свободы» УК РФ ограничение свободы не назначается военнослужащим, иностранным гражданам, лицам без гражданства, а также лицам, не имеющим места постоянного проживания на территории Российской Федерации",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let ug_p21ext_1_13 = {
	"name": "ug_p21ext_1_13",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Что понимается под применением уголовного закона по аналогии?",
				"correct_ans": [
					{
						"ans": "Привлечение к уголовной ответственности за действия(бездействие), не указанные прямо в УК РФ, но сходные с обозначенными в нем преступлениями",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Применение мер уголовного наказания за деяния, которые ранее признавались преступлениями, но были исключены из УК РФ по причине присоединения России к соответствующим многосторонним международным договорам",
						"score": 0
					},
					{
						"ans": "Привлечение к уголовной ответственности \"социально-опасных элементов\", не совершивших никакого преступления, но \"опасных своими связями с преступной средой\"",
						"score": 0
					},
					{
						"ans": "Массовые убийства заложников",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Теорией уголовного права установлено, что уголовный закон применяется лишь в том случае, когда признаки совершенного деяния полностью совпадают с признаками состава преступления, указанными в УК РФ. Применение уголовного закона к сходным действиям или общественным отношениям недопустимы (как аналогия закона, так и аналогия права)"
}

export let ug_p21ext_1_244 = {
	"name": "ug_p21ext_1_244",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Что имел в виду законодатель под понятием \"аффект\", включенным в число признаков состава преступления, предусмотренного ст. 107 УК РФ?",
				"correct_ans": [
					{
						"ans": "Состояние внезапно возникшего сильного душевного волнения, вызванного насилием, издевательством или тяжким оскорблением со стороны потерпевшего либо иными противоправными или аморальными действиями (бездействием) потерпевшего, а равно длительной психотравмирующей ситуацией, возникшей в связи с систематическим противоправным или аморальным поведением потерпевшего",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Кратковременную интенсивную эмоциональную вспышку (сильное душевное волнение), которая занимает доминирующее (господствующее) положение в сознании человека при сохранении потенциальной способности к самообладанию и возможность действовать рационально",
						"score": 0
					},
					{
						"ans": "Умоисступление, т.е. временный выход за пределы разума",
						"score": 0
					},
					{
						"ans": "Обиду на потерпевшего",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Согласно ст. 107 УК РФ под состоянием аффекта понимается внезапно возникшее сильное душевное волнение, вызванное насилием, издевательством или тяжким оскорблением со стороны потерпевшего либо иными противоправными или аморальными действиями (бездействием) потерпевшего, а равно длительной психотравмирующей ситуацией, возникшей в связи с систематическим противоправным или аморальным поведением потерпевшего"
}

export let ug_p21ext_1_7 = {
	"name": "ug_p21ext_1_7",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Каким нормативным актом могут вноситься непосредственные изменения и дополнения в Уголовный кодекс Российской Федерации?",
				"correct_ans": [
					{
						"comm": "По правилам законодательной техники тот орган, который принял нормативный акт, имеет право по той же процедуре вносить в него изменения, поэтому в федеральный закон, т. е. УК РФ, изменения могут вноситься федеральным законом.",
						"ans": "Федеральным законом",
						"score": 54
					},
					{
						"comm": "Согласно ст. 125 Конституции РФ Конституционный Суд РФ по установленной процедуре разрешает дела о соответствии Конституции федеральных законов. Акты или их отдельные положения, признанные неконституционными, утрачивают силу.",
						"ans": "Постановлением Конституционного суда Российской Федерации",
						"score": 54
					}
				],
				"wrong_ans": [
					{
						"ans": "Постановлением Государственной Думы Федерального Собрания Российской Федерации",
						"score": 0
					},
					{
						"ans": "Указом Президента Российской Федерации",
						"score": 0
					},
					{
						"ans": "Постановлением Правительства Российской Федерации",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "По правилам законодательной техники тот орган, который принял нормативный акт, имеет право по той же процедуре вносить в него изменения, поэтому в федеральный закон, т.е. УК РФ, изменения могут вноситься федеральным законом",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let ug_p21ext_1_62 = {
	"name": "ug_p21ext_1_62",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Что такое субъективная сторона состава преступления?",
				"correct_ans": [
					{
						"ans": "Психическое отношение виновного к совершаемому им общественно опасному деянию, предусмотренному уголовным законом в качестве преступления и к наступившему последствию для материальных составов преступления",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Своеобразная \"модель\" объективной стороны состава в психике субъекта",
						"score": 0
					},
					{
						"ans": "Совокупность вины и желания совершить деяние",
						"score": 0
					},
					{
						"ans": "Характер действия виновного в совершении преступления",
						"score": 0
					},
					{
						"ans": "Психическое отношение лица к общественно опасному деянию, предусмотренному уголовным законом в качестве преступления",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Субъективная сторона состава преступления отражает психическое отношение виновного к совершаемому им общественно опасному деянию, предусмотренному уголовным законом в качестве преступления и к наступившему последствию для материальных составов преступления"
}

export let ug_p21ext_1_299 = {
	"name": "ug_p21ext_1_299",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "В каких альтернативных действиях выражается объективная сторона бандитизма?",
				"correct_ans": [
					{
						"ans": "Создание устойчивой вооруженной группы",
						"score": 36
					},
					{
						"ans": "Участие в устойчивой вооруженной группе или в совершаемых ею нападениях",
						"score": 36
					},
					{
						"ans": "Руководство устойчивой вооруженной группой",
						"score": 36
					}
				],
				"wrong_ans": [
					{
						"ans": "Хищении чужого имущества с применением насилия опасного для жизни и здоровья",
						"score": 0
					},
					{
						"ans": "В требовании передачи имущества под угрозой применения насилия",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Объективная сторона бандитизма, согласно ст.209 «Бандитизм» УК РФ, выражается в: 1) создании устойчивой вооруженной группы (банды), а равно 2) руководстве такой группой (бандой), а также в 3) участии в устойчивой вооруженной группе (банде) или в совершаемых ею нападениях",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let ug_p21ext_1_197 = {
	"name": "ug_p21ext_1_197",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Чем отличается амнистия от помилования?",
				"correct_ans": [
					{
						"comm": "Согласно ст. 84 «Амнистия» и ст. 85 «Помилование» УК РФ помилование осуществляется Президентом Российской Федерации, а амнистия объявляется Государственной Думой Федерального Собрания Российской Федерации.",
						"ans": "Помилование осуществляется Президентом Российской Федерации, а амнистия объявляется Государственной Думой Федерального Собрания Российской Федерации",
						"score": 36
					},
					{
						"comm": "Согласно ст. 84 «Амнистия» и ст. 85 «Помилование» УК РФ амнистия объявляется в отношении индивидуально не определенного круга лиц, а помилование осуществляется только в отношении конкретного лица.",
						"ans": "Амнистия объявляется в отношении индивидуально не определенного круга лиц, а помилование осуществляется только в отношении конкретного лица",
						"score": 36
					},
					{
						"comm": "Согласно ст. 84 «Амнистия» и ст. 85 «Помилование» УК РФ актом об амнистии лица, совершившие преступления, могут быть освобождены от уголовной ответственности, а помилование освобождает от дальнейшего отбывания наказания.",
						"ans": "Актом об амнистии лица, совершившие преступления, могут быть освобождены от уголовной ответственности, а помилование освобождает от дальнейшего отбывания наказания",
						"score": 36
					}
				],
				"wrong_ans": [
					{
						"ans": "Акт амнистии идентичен помилованию",
						"score": 0
					},
					{
						"ans": "Амнистия от помилования отличается только тем, что амнистию объявляет Государственная Дума, а помилование - Президент Российской Федерации",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Согласно ст. 84 «Амнистия» и ст. 85 «Помилование» УК РФ помилование осуществляется Президентом Российской Федерации, а амнистия объявляется Государственной Думой Федерального Собрания Российской Федерации",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let ug_p21ext_1_195 = {
	"name": "ug_p21ext_1_195",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Какие правовые последствия влечет акт об амнистии?",
				"correct_ans": [
					{
						"ans": "Освобождение от уголовной ответственности",
						"score": 22
					},
					{
						"ans": "Осужденные освобождаются от отбывания наказания",
						"score": 22
					},
					{
						"ans": "Наказание может быть сокращено или заменено более мягким видом наказания",
						"score": 22
					},
					{
						"ans": "Освобождение от дополнительного наказания",
						"score": 21
					},
					{
						"ans": "С лиц, отбывших наказание, может быть снята судимость",
						"score": 21
					}
				],
				"wrong_ans": [
					{
						"ans": "Назначено более мягкое наказание, чем предусмотрено за данное преступение",
						"score": 0
					},
					{
						"ans": "Наказание не может превышать двух третей максимального срока или размера максимального наказания, предусмотренного за совершенное преступление",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "По ст. 84 «Амнистия» УК актом об амнистии лица, совершившие преступления, могут быть освобождены от уголовной ответственности. Лица, осужденные за совершение преступлений, могут быть освобождены от наказания, либо назначенное им наказание может быть сокращено или заменено более мягким видом наказания, либо такие лица могут быть освобождены от дополнительного вида наказания. С лиц, отбывших наказание, актом об амнистии может быть снята судимость",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let ug_p21ext_1_250 = {
	"name": "ug_p21ext_1_250",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Что понимает законодатель под незаконным лишением свободы в смысле диспозиции ст. 127 УК РФ?",
				"correct_ans": [
					{
						"ans": "Незаконное лишение лица возможности передвижения в пространстве и выбора им места нахождения",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Тайный, открытый либо с помощью обмана захват и перемещение человека с места его пребывания в другое с последующим удержанием помимо его воли",
						"score": 0
					},
					{
						"ans": "Незаконный арест или задержание, а также незаконное содержание под стражей, несмотря на отсутствие основания для содержания",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "По постановлению Пленума Верховного Суда РФ от 24.12.2019 N 58 \"О судебной практике по делам о похищении человека, незаконном лишении свободы и торговле людьми\" при незаконном лишении свободы, предусмотренном статьей 127 УК РФ, потерпевший остается в месте его нахождения, но ограничивается в передвижении без законных на то оснований (например, виновное лицо закрывает потерпевшего в доме, квартире или ином помещении, где он находится, связывает его или иным образом лишает возможности покинуть какое-либо место). Деяние, предусмотренное статьей 127 УК РФ, представляет собой оконченное преступление с момента фактического лишения человека свободы независимо от длительности пребывания потерпевшего в таком состоянии"
}

export let ug_p21ext_1_167 = {
	"name": "ug_p21ext_1_167",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Ограничивает ли закон срок и размер наказания за покушение на преступление?",
				"correct_ans": [
					{
						"ans": "Срок или размер наказания за покушение на преступление не может превышать трех четвертей максимального срока или размера наиболее строгого вида наказания, предусмотренного соответствующей статьей Особенной части УК РФ за оконченное преступление",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Да, ограничивает по усмотрению суда",
						"score": 0
					},
					{
						"ans": "Срок наказания за покушение на преступление не может быть ниже половины максимального срока за оконченное преступление",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Согласно ст.66 «Назначение наказания за неоконченное преступление» срок или размер наказания за покушение на преступление не может превышать трех четвертей максимального срока или размера наиболее строгого вида наказания, предусмотренного соответствующей статьей Особенной части УК РФ за оконченное преступление"
}

export let ug_p21ext_1_191 = {
	"name": "ug_p21ext_1_191",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Какова судьба дополнительного наказания при условно-досрочном освобождения от отбывания наказания?",
				"correct_ans": [
					{
						"ans": "Лицо может быть полностью или частично освобождено от отбывания дополнительного вида наказания",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Лицо освобождается от отбытия только основного наказания и полностью отбывает дополнительное",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "По ст. 79 «Условно-досрочное освобождение от отбывания наказания» УК РФ лицо может быть полностью или частично освобождено от отбывания дополнительного вида наказания"
}

export let ug_p21ext_1_79 = {
	"name": "ug_p21ext_1_79",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Кто может быть субъектом преступления?",
				"correct_ans": [
					{
						"ans": "Только физические лица, достигшие установленного уголовным законом возраста, вменяемые",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Только физические лица",
						"score": 0
					},
					{
						"ans": "Физические и юридические лица",
						"score": 0
					},
					{
						"ans": "Только юридические лица",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Согласно ст. 19 УК РФ уголовной ответственности подлежит только вменяемое физическое лицо, достигшее возраста, установленного настоящим УК РФ"
}

export let ug_p21ext_1_104 = {
	"name": "ug_p21ext_1_104",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "К какому виду соучастников относится лицо, организовавшее совершение преступления или руководившее его исполнением, а равно создавшее организованную группу или преступное сообщество (преступную организацию) либо руководящее ими?",
				"correct_ans": [
					{
						"ans": "Организатор",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Пособник",
						"score": 0
					},
					{
						"ans": "Подстрекатель",
						"score": 0
					},
					{
						"ans": "Исполнитель",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Статья 33 «Виды соучастников преступлений» УК РФ определяет, что организатором признается лицо, организовавшее совершение преступления или руководившее его исполнением, а равно лицо, создавшее организованную группу или преступное сообщество (преступную организацию) либо руководившее ими"
}

export let ug_p21ext_1_271 = {
	"name": "ug_p21ext_1_271",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Каким образом характеризуется вина как признак субъективной стороны состава преступления, предусмотренного ст. 276 УК РФ «Шпионаж»?",
				"correct_ans": [
					{
						"ans": "Только прямым умыслом",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Как прямым, так и косвенным умыслом",
						"score": 0
					},
					{
						"ans": "Как умыслом, так и неосторожностью",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Субъективная сторона состава преступления, предусмотренного ст. 276 «Шпионаж» УК РФ характеризуется виной в виде прямого умысла, специальной целью - передачи иностранному государству, международной либо иностранной организации или их представителям сведений, составляющих государственную тайну и мотивом - задание иностранной разведки или лица, действующего в ее интересах. Виновный осознает общественную опасность своего деяния и желает действовать подобным образом"
}

export let ug_p21ext_1_148 = {
	"name": "ug_p21ext_1_148",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Каким категориям подсудимых не назначается пожизненное лишение свободы?",
				"correct_ans": [
					{
						"ans": "Женщинам",
						"score": 36
					},
					{
						"ans": "Лицам, совершившим преступления в возрасте до 18 лет",
						"score": 36
					},
					{
						"ans": "Мужчинам, достигшим к моменту вынесения судом приговора возраста 65-лет",
						"score": 36
					}
				],
				"wrong_ans": [
					{
						"ans": "Лицам, страдающим психическими расстройствами, не исключающими вменяемость",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Согласно ст. 57 «Пожизненное лишение свободы» УК РФ пожизненное лишение свободы не назначается женщинам, а также лицам, совершившим преступления в возрасте до восемнадцати лет, и мужчинам, достигшим к моменту вынесения судом приговора шестидесятипятилетнего возраста",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let ug_p21ext_1_14 = {
	"name": "ug_p21ext_1_14",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Каким образом ст. 9 Уголовного кодекса РФ отражает действие уголовного закона во времени?",
				"correct_ans": [
					{
						"ans": "Преступность и наказуемость деяния определяется уголовным законом, действующим во время совершения преступления",
						"score": 54
					},
					{
						"ans": "Временем совершения преступления признается время совершения общественно опасного действия (бездействия) независимо от времени наступления последствий",
						"score": 54
					}
				],
				"wrong_ans": [
					{
						"ans": "Преступность и наказуемость деяния определяется уголовным законом, действовавшим в момент наступления общественно опасных последствий",
						"score": 0
					},
					{
						"ans": "Преступность и наказуемость определяется уголовным законом, действующим в момент судебного разбирательства",
						"score": 0
					},
					{
						"ans": "Преступность и наказуемость определяется степенью общественной опасности деяния в данный момент, даже если еще не принят уголовный закон об ответственности за это деяние",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Статья 9 «Действие уголовного закона во времени» УК РФ устанавливает, что: 1. Преступность и наказуемость деяния определяются уголовным законом, действовавшим во время совершения этого деяния; 2. Временем совершения преступления признается время совершения общественно опасного действия (бездействия) независимо от времени наступления последствий"
}

export let ug_p21ext_1_179 = {
	"name": "ug_p21ext_1_179",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "На каком этапе судопроизводства исключается возможность освобождения лица от уголовной ответственности?",
				"correct_ans": [
					{
						"ans": "После вынесения судом обвинительного приговора",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "На стадии возбуждения уголовного дела",
						"score": 0
					},
					{
						"ans": "После предъявления обвинения",
						"score": 0
					},
					{
						"ans": "На стадии предания суду",
						"score": 0
					},
					{
						"ans": "На стадии судебного разбирательства",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Теорией уголовного права разработано положение, согласно которому освобождение от уголовной ответственности может быть реализовано (при наличии соответствующих условий) только до вынесения судом обвинительного приговора"
}

export let ug_p21ext_1_107 = {
	"name": "ug_p21ext_1_107",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "За что может нести ответственность лицо, которому по не зависящим от него обстоятельствам не удалось склонить других лиц к совершению преступления?",
				"correct_ans": [
					{
						"ans": "За приготовление к преступлению",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Не несет ответственности",
						"score": 0
					},
					{
						"ans": "За покушение на преступление",
						"score": 0
					},
					{
						"ans": "За оконченное преступление",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Статья 34 «Ответственность соучастников преступления» УК РФ определяет, что за приготовление к преступлению несет уголовную ответственность также лицо, которому по не зависящим от него обстоятельствам не удалось склонить других лиц к совершению преступления"
}

export let ug_p21ext_1_105 = {
	"name": "ug_p21ext_1_105",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "В чем заключается отличие подстрекателя от исполнителя?",
				"correct_ans": [
					{
						"ans": "Подстрекатель возбуждает желание совершить преступление, а исполнитель непосредственно совершает преступление",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Подстрекательство возможно только при неоконченном преступлении, а исполнитель совершает оконченное преступление",
						"score": 0
					},
					{
						"ans": "Подстрекатель не выполняет объективной стороны состава преступления, а исполнитель реализует ее в полном объеме",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Статья 33 «Виды соучастников преступлений» УК РФ определяет, что исполнителем признается лицо, непосредственно совершившее преступление либо непосредственно участвовавшее в его совершении совместно с другими лицами (соисполнителями), а также лицо, совершившее преступление посредством использования других лиц, не подлежащих уголовной ответственности в силу возраста, невменяемости или других обстоятельств, предусмотренных УК РФ. Подстрекателем признается лицо, склонившее другое лицо к совершению преступления путем уговора, подкупа, угрозы или другим способом"
}

export let ug_p21ext_1_76 = {
	"name": "ug_p21ext_1_76",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Что такое обусловленное потребностями и интересами внутреннее побуждение (побудительный стимул), вызывающее решимость совершить умышленное преступление?",
				"correct_ans": [
					{
						"ans": "Мотив",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Проблема",
						"score": 0
					},
					{
						"ans": "Задача",
						"score": 0
					},
					{
						"ans": "Умысел",
						"score": 0
					},
					{
						"ans": "Цель",
						"score": 0
					},
					{
						"ans": "Вина",
						"score": 0
					},
					{
						"ans": "Намерение",
						"score": 0
					},
					{
						"ans": "Побуждение",
						"score": 0
					},
					{
						"ans": "Установка",
						"score": 0
					},
					{
						"ans": "Ценностная ориентация",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Побудительный стимул, источник активности человека – это мотив"
}

export let ug_p21ext_1_41 = {
	"name": "ug_p21ext_1_41",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Какие категории преступлений предусматривает действующее уголовное законодательство Российской Федерации (ст. 15 УК РФ)?",
				"correct_ans": [
					{
						"ans": "Небольшой тяжести",
						"score": 27
					},
					{
						"ans": "Тяжкие",
						"score": 27
					},
					{
						"ans": "Средней тяжести",
						"score": 27
					},
					{
						"ans": "Особо тяжкие",
						"score": 27
					}
				],
				"wrong_ans": [
					{
						"ans": "Иные",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "Согласно ст. 15 УК РФ в зависимости от характера и степени общественной опасности деяния, предусмотренные УК РФ, подразделяются на преступления небольшой тяжести, преступления средней тяжести, тяжкие преступления и особо тяжкие преступления",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

export let ug_p21ext_1_174 = {
	"name": "ug_p21ext_1_174",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Могут ли при условном осуждении быть назначены дополнительные виды уголовного наказания?",
				"correct_ans": [
					{
						"ans": "Могут",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Нет, не могут",
						"score": 0
					},
					{
						"ans": "Могут, за исключением ограничения свободы",
						"score": 0
					},
					{
						"ans": "Могут, кроме лишения специального, воинского, почетного звания, классного чина, государственных наград",
						"score": 0
					},
					{
						"ans": "Могут, кроме штрафа",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Согласно ст.73 «Условное осуждение» УК РФ при условном осуждении также могут быть назначены дополнительные виды наказаний"
}

export let ug_p21ext_1_30 = {
	"name": "ug_p21ext_1_30",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Является ли доктринальное толкование уголовного закона обязательным для правоприменителя?",
				"correct_ans": [
					{
						"ans": "Нет, не обязательно",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Да, обязательно",
						"score": 0
					},
					{
						"ans": "Обязательно только в отдельных случаях по конкретным уголовным делам",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "Положения доктринального толкования уголовного закона, являются необязательными для правоприменителя (обязательное значения имеют лишь положения УК РФ)"
}

export let ug_p21ext_1_292 = {
	"name": "ug_p21ext_1_292",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Возможно ли привлечение лица в возрасте 14 лет к уголовной ответственности?",
				"correct_ans": [
					{
						"ans": "Да, возможно, в случае совершения преступлений, указанных в ст.20 УК РФ «Возраст, с которого наступает уголовная ответственность»",
						"score": 108
					}
				],
				"wrong_ans": [
					{
						"ans": "Нет, невозможно, т.к. возраст уголовной ответственности 16 лет",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "Question",
	"comm": "В ч.2 статьи 20 «Возраст, с которого наступает уголовная ответственность» указан перечень статей УК РФ субъект которых характеризуется, т.н. пониженным возрастом уголовной ответственности – 14 лет. По мнению законодателя общественная опасность указанных составов преступлений очевидна и понятна с указанного возраста"
}

export let ug_p21ext_1_102 = {
	"name": "ug_p21ext_1_102",
	"descriprion": "type1",
	"theme": "Уголовное право РФ",
	"title": "Уголовное право РФ",
	"data": {
		"questions": [
			{
				"qst": "Перечислите соучастников преступления",
				"correct_ans": [
					{
						"ans": "Организатор",
						"score": 27
					},
					{
						"ans": "Исполнитель",
						"score": 27
					},
					{
						"ans": "Подстрекатель",
						"score": 27
					},
					{
						"ans": "Пособник",
						"score": 27
					}
				],
				"wrong_ans": [
					{
						"ans": "Укрыватель",
						"score": 0
					},
					{
						"ans": "Соучредитель",
						"score": 0
					},
					{
						"ans": "Помощник",
						"score": 0
					},
					{
						"ans": "Подельник",
						"score": 0
					},
					{
						"ans": "Сочувствующий",
						"score": 0
					}
				]
			}
		]
	},
	"minigameType": "ManyAnsQuestion",
	"comm": "В соответствии со ст. 33 «Виды соучастников преступления» УК РФ соучастниками преступления наряду с исполнителем признаются организатор, подстрекатель и пособник",
	"EstPos": "sum",
	"EstNeg": "min",
	"EstMix": "min"
}

